import { HelpIcon } from './Icons/TooltipIcon';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/Components/ui/dialog";
import PlanPage from "@/Components/Training/PlanPage";
import CharterPage from "@/Components/Training/CharterPage";
import MenuPage from "@/Components/Training/MenuPage";
import RiskPage from "@/Components/Training/RiskPage";
import ActionPage from '@/Components/Training/ActionPage';
import IssuePage from '@/Components/Training/IssuePage';
import DecisionPage from '@/Components/Training/DecisionPage';
import SupportPage from '@/Components/Training/SupportPage';
import React from 'react';
import StatusReportPage from '../Training/StatusReportPage';
import { useIsMobile } from '@/hooks/use-mobile';
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import DashboardPage from '../Training/DashboardPage';
import TeamPage from '../Training/TeamPage';

interface HelpLinkProps {
  page: string;
}

const HelpLink = ({ page }: HelpLinkProps) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const isMobile = useIsMobile();
  const zoomLevel = useResponsiveZoom();

  function getDialogContent() {
    switch (page) {
      case "plan":
        return <PlanPage />;
      case "charter":
        return <CharterPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "menu":
        return <MenuPage />;
      case "risk":
        return <RiskPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "action":
        return <ActionPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "issue":
        return <IssuePage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "decision":
        return <DecisionPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "support":
        return <SupportPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "status_report":
        return <StatusReportPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "MultiProjectDash":
          return <DashboardPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      case "team":
          return <TeamPage showWizardLinks={true} setDialogOpen={setDialogOpen} />;
      default:
        return null;
    }
  }

  function getDialogTitle() {
    switch (page) {
      case "plan":
        return "Plan Page Help";
      case "charter":
        return "Charter Page Help";
      case "menu":
        return "Menu Help";
      case "risk":
        return "Risk Page Help";
      case "action":
        return "Action Page Help";
      case "issue":
        return "Issue Page Help";
      case "decision":
        return "Decision Page Help";
      case "support":
        return "Support Page Help";
      case "MultiProjectDash":
        return "Multi-Project Dashboard Help";
      case "team":
        return "Team Page Help";
      default:
        return "Help";
    }
  }

  return (
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogTrigger asChild>
          <button className="text-accent p-1 my-auto mx-2 rounded-full w-min hover:bg-accent hover:text-accent-foreground" onClick={(e) => { e.stopPropagation(); setDialogOpen(true); }}>
            <HelpIcon className={`w-5 h-5 ${isMobile ? 'w-7 h-7' : ''}`} />
          </button>
        </DialogTrigger>
        <DialogContent className="flex flex-col max-w-fitflex flex-col w-[1600px]" style={{ zoom: zoomLevel }}>
          <DialogHeader>
            <DialogTitle>{getDialogTitle()}</DialogTitle>
          </DialogHeader>
          {getDialogContent()}
        </DialogContent>
      </Dialog>
  )
}

export default HelpLink